

























import Vue from 'vue';
import FooterSimple from '@/parts/common/FooterSimple.vue';
import { validate } from "@/api/Login";

export default Vue.extend({
  name: 'Validate',
  components: {
    FooterSimple,
  },
  data() {
    return {
      isValidate: true,
      message: ""
    }
  },
  async created() {
    try {
      var id = this.$route.params.id.toString()
      var res = await validate(id);
      if (res.isValidate == false) {
        this.isValidate = false
        this.message = res.message;
        return;
      }

      // ユーザーの検証結果が問題なければログインする
      this.$store.dispatch("loginRegisterUsers",{id:id});
    } catch (e) {
      this.isValidate = false
    }
  },
  methods: {
    onPushPath(path: string) {
    this.$router.push(path, () => {}); // eslint-disable-line
    this.$emit('pushPath', path);
    },

    
  }
})
